export const TAG_SHEET_RESULT_STEP_TITLE = 'Results';

export const TAG_SHEET_RESULT_ERROR_ALERT_MESSAGE =
  'Something went wrong during saving tag sheet ads. Please try later.';

export const TAG_SHEET_RESULT_CONFIRM_BUTTON_TEXT = 'Close';

export const GENERIC_BATCH_FAILURE_MESSAGE = 'Creation failed. Please try again.';
